<template>
	<form class="form" @submit.prevent="submit" novalidate>
		<fieldset class="form__group">
			<ValidationAlert :error-list="errors.collect('server')"></ValidationAlert>
			<legend>The Deal</legend>
			<div class="grid">
				<div class="form__group col-12">
					<FormControlSector
                        name="sectors"
                        v-model="formData.sectors"
                        v-validate="'required'"
                        value-format="object"
                        :multiple="true"
                    />
				</div>
				<div class="form__group col-12" v-if="formData.sectors">
                    <div class="form__group">
                        <select name="primary-sector" v-model="formData.primarySector" class="form__control">
                            <option
                                v-for="sector in formData.sectors"
                                :id='`primary-sector-${sector.id}`'
                                :value="sector.id"
                            >
                                {{ sector.name }}
                            </option>
                        </select>
                        <label for="filter" class="form__label">Main Category:</label>
                    </div>
				</div>

				<div class="form__group col-12">
					<textarea
                        id="summary"
                        name="deal summary"
                        class="form__control"
                        v-model="formData.dealSummary"
                        placeholder="Enter your summary here..."
                        v-validate
                        required
                    />
					<label for="summary" class="form__label">Summary</label>
					<div class="form__validation">{{ errors.first('deal summary') }}</div>
				</div>

				<div class="form__group col-6">
					<FormControlCurrency
                        name="currency"
                        v-model="formData.transactionCurrency"
                        v-validate="'required'"
                    />
				</div>
				<div class="form__group col-6">
					<input
                        id="value"
                        name="transaction value"
                        class="form__control"
                        v-model.number="formData.transactionValue"
                        placeholder="Enter the transaction value..."
                        type="number"
                        v-validate="'required'"
                    />
					<label for="value" class="form__label">Transaction Value (in millions)</label>
					<div class="form__validation">{{ errors.first('transaction value') }}</div>
				</div>

				<div class="form__group col-12">
					<div class="toggle-group">
						<input
                            id="not-members-only"
                            name="members only"
                            class="toggle"
                            type="radio"
                            :value="false"
                            v-model="formData.membersOnly"
                            v-validate
                            required
                        />
						<label for="not-members-only" class="toggle">Yes</label>
						<input
                            id="is-members-only"
                            name="members only"
                            class="toggle"
                            type="radio"
                            :value="true"
                            v-model="formData.membersOnly"
                            v-validate
                            required
                        />
						<label for="is-members-only" class="toggle">No</label>
					</div>
					<label class="form__label">Show deal on the MA website?</label>
					<div class="form__validation">{{ errors.first('members only') }}</div>
				</div>

				<div v-if="formData.membersOnly === false" class="form__group col-12">
					<div class="toggle-group">
						<input
                            id="show-transaction-value"
                            name="show transaction value"
                            class="toggle"
                            type="radio"
                            :value="true"
                            v-model="formData.showTransactionValue"
                        />
						<label for="show-transaction-value" class="toggle">Yes</label>
						<input
                            id="hide-transaciton-value"
                            name="show transaction value"
                            class="toggle"
                            type="radio"
                            :value="false"
                            v-model="formData.showTransactionValue"
                        />
						<label for="hide-transaciton-value" class="toggle">No</label>
					</div>
					<label class="form__label">Show transaction value on the MA website?</label>
					<div class="form__validation">{{ errors.first('show transaction value') }}</div>
				</div>
				<div class="form__group col-12 form__group--submit">
					<button class="btn" @click.prevent="back" v-wait:disabled='"submit"'>Back</button>
					<button class="btn btn--primary" v-wait:disabled='"submit"'>Save &amp; Continue</button>
				</div>
			</div>
		</fieldset>
	</form>
</template>

<script>
	import FormControlCurrency from '../../Form/Control/FormControlCurrency';
	import MADDFormStep from './MADDFormStep';
	import ValidationAlert from '../../ValidationAlert';
	import FormControlSector from '../../Form/Control/FormControlSector';

	export default {
		name: 'MADDFormStep3',
		mixins: [MADDFormStep],
		components: {
			FormControlSector,
			ValidationAlert,
			FormControlCurrency,
		},
		data() {
			return {
				formData: {
					sectors: [],
                    primarySector: null,
					dealSummary: null,
					showTransactionValue: false,
					transactionCurrency: null,
					transactionValue: null,
					membersOnly: null,
				}
			}
		},
	}
</script>
